// extracted by mini-css-extract-plugin
export var acceptButton = "_3b-5";
export var fullContent = "_3b-4";
export var link = "_3b-6";
export var linkIcon = "_3b-7";
export var sideContent = "_3b-3";
export var sideImage = "_3b-2";
export var sideImageWrapper = "_3b-1";
export var splitLayout = "_3b-0";